export const BUSINESS_PROCESS_CLASS_GROUPS = [
  {
    key: "valueDelivery",
    labelKey: "businessProcess.classGroup.valueDelivery",
    values: [
      { value: "ProductProductionAndDelivery",                   labelKey: "businessProcess.class.productProductionAndDelivery" },
      { value: "ServiceDelivery",                                 labelKey: "businessProcess.class.serviceDelivery" },
      { value: "ProductDeliveryImprovement",                      labelKey: "businessProcess.class.productDeliveryImprovement" },
      { value: "ProductPriceImprovement",                         labelKey: "businessProcess.class.productPriceImprovement" },
      { value: "ProductQualityImprovement",                       labelKey: "businessProcess.class.productQualityImprovement" },
      { value: "ProductFunctionImprovement",                      labelKey: "businessProcess.class.productFunctionImprovement" },
      { value: "ServiceDeliveryImprovement",                      labelKey: "businessProcess.class.serviceDeliveryImprovement" },
      { value: "ServicePriceImprovement",                         labelKey: "businessProcess.class.servicePriceImprovement" },
      { value: "ServiceQualityImprovement",                       labelKey: "businessProcess.class.serviceQualityImprovement" },
      { value: "ServiceContentImprovement",                       labelKey: "businessProcess.class.serviceContentImprovement" },
      { value: "ProductDeliveryImprovementConstraintControl",     labelKey: "businessProcess.class.productDeliveryImprovementCC" },
      { value: "ProductPriceImprovementConstraintControl",        labelKey: "businessProcess.class.productPriceImprovementCC" },
      { value: "ProductQualityImprovementConstraintControl",      labelKey: "businessProcess.class.productQualityImprovementCC" },
      { value: "ProductFunctionImprovementConstraintControl",     labelKey: "businessProcess.class.productFunctionImprovementCC" },
      { value: "ServiceDeliveryImprovementConstraintControl",     labelKey: "businessProcess.class.serviceDeliveryImprovementCC" },
      { value: "ServicePriceImprovementConstraintControl",        labelKey: "businessProcess.class.servicePriceImprovementCC" },
      { value: "ServiceQualityImprovementConstraintControl",      labelKey: "businessProcess.class.serviceQualityImprovementCC" },
      { value: "ServiceContentImprovementConstraintControl",      labelKey: "businessProcess.class.serviceContentImprovementCC" },
    ],
  },
  {
    key: "valueCommunication",
    labelKey: "businessProcess.classGroup.valueCommunication",
    values: [
      { value: "ProductAndServiceSales",              labelKey: "businessProcess.class.productAndServiceSales" },
      { value: "Marketing",                            labelKey: "businessProcess.class.marketing" },
      { value: "CustomerActivation",                   labelKey: "businessProcess.class.customerActivation" },
      { value: "CustomerRetention",                    labelKey: "businessProcess.class.customerRetention" },
      { value: "SalesConstraintControl",               labelKey: "businessProcess.class.salesCC" },
      { value: "MarketingConstraintControl",           labelKey: "businessProcess.class.marketingCC" },
      { value: "CustomerActivationConstraintControl",  labelKey: "businessProcess.class.customerActivationCC" },
      { value: "CustomerRetentionConstraintControl",   labelKey: "businessProcess.class.customerRetentionCC" },
    ],
  },
  {
    key: "valueCreation",
    labelKey: "businessProcess.classGroup.valueCreation",
    values: [
      { value: "NewProductQualityExploration",                  labelKey: "businessProcess.class.newProductQualityExploration" },
      { value: "NewProductValueExploration",                    labelKey: "businessProcess.class.newProductValueExploration" },
      { value: "NewServiceQualityExploration",                  labelKey: "businessProcess.class.newServiceQualityExploration" },
      { value: "NewServiceValueExploration",                    labelKey: "businessProcess.class.newServiceValueExploration" },
      { value: "NewProductQualityExplorationConstraintControl", labelKey: "businessProcess.class.newProductQualityExplorationCC" },
      { value: "NewProductValueExplorationConstraintControl",   labelKey: "businessProcess.class.newProductValueExplorationCC" },
      { value: "NewServiceQualityExplorationConstraintControl", labelKey: "businessProcess.class.newServiceQualityExplorationCC" },
      { value: "NewServiceValueExplorationConstraintControl",   labelKey: "businessProcess.class.newServiceValueExplorationCC" },
    ],
  },
  {
    key: "humanCapital",
    labelKey: "businessProcess.classGroup.humanCapital",
    values: [
      { value: "OrganizationManagement",                    labelKey: "businessProcess.class.organizationManagement" },
      { value: "JobCapabilityImprovement",                  labelKey: "businessProcess.class.jobCapabilityImprovement" },
      { value: "JobCapabilityImprovementConstraintControl", labelKey: "businessProcess.class.jobCapabilityImprovementCC" },
    ],
  },
  {
    key: "informationCapital",
    labelKey: "businessProcess.classGroup.informationCapital",
    values: [
      { value: "ApplicationManagement",                           labelKey: "businessProcess.class.applicationManagement" },
      { value: "DataLifecycleManagement",                         labelKey: "businessProcess.class.dataLifecycleManagement" },
      { value: "ITManagement",                                    labelKey: "businessProcess.class.itManagement" },
      { value: "ApplicationQualityImprovement",                   labelKey: "businessProcess.class.applicationQualityImprovement" },
      { value: "DataQualityImprovement",                          labelKey: "businessProcess.class.dataQualityImprovement" },
      { value: "ITQualityImprovement",                            labelKey: "businessProcess.class.itQualityImprovement" },
      { value: "ApplicationQualityImprovementConstraintControl",  labelKey: "businessProcess.class.applicationQualityImprovementCC" },
      { value: "DataQualityImprovementConstraintControl",         labelKey: "businessProcess.class.dataQualityImprovementCC" },
      { value: "ITQualityImprovementConstraintControl",           labelKey: "businessProcess.class.itQualityImprovementCC" },
    ],
  },
  {
    key: "organizationCapital",
    labelKey: "businessProcess.classGroup.organizationCapital",
    values: [
      { value: "HumanResourceManagement",                      labelKey: "businessProcess.class.humanResourceManagement" },
      { value: "PartnerRelationshipManagement",                 labelKey: "businessProcess.class.partnerRelationshipManagement" },
      { value: "CorporateCultureDevelopment",                   labelKey: "businessProcess.class.corporateCultureDevelopment" },
      { value: "CorporateCultureDevelopmentConstraintControl",  labelKey: "businessProcess.class.corporateCultureDevelopmentCC" },
    ],
  },
  {
    key: "cashFlow",
    labelKey: "businessProcess.classGroup.cashFlow",
    values: [
      { value: "BillingAndReceivablesManagement", labelKey: "businessProcess.class.billingAndReceivablesManagement" },
      { value: "PaymentAndPayablesManagement",    labelKey: "businessProcess.class.paymentAndPayablesManagement" },
    ],
  },
  {
    key: "logistics",
    labelKey: "businessProcess.classGroup.logistics",
    values: [
      { value: "ProductAndPartsReceiving",           labelKey: "businessProcess.class.productAndPartsReceiving" },
      { value: "ProductAndPartsShipping",            labelKey: "businessProcess.class.productAndPartsShipping" },
      { value: "ProductAndPartsInventoryManagement", labelKey: "businessProcess.class.productAndPartsInventoryManagement" },
    ],
  },
  {
    key: "facilityManagement",
    labelKey: "businessProcess.classGroup.facilityManagement",
    values: [
      { value: "AssetManagement", labelKey: "businessProcess.class.assetManagement" },
    ],
  },
  {
    key: "enterpriseSupport",
    labelKey: "businessProcess.classGroup.enterpriseSupport",
    values: [
      { value: "Financing",         labelKey: "businessProcess.class.financing" },
      { value: "GeneralManagement", labelKey: "businessProcess.class.generalManagement" },
    ],
  },
];

// 現在使用されていない旧enum値（DBに残存する可能性があるため翻訳キーを保持）
export const LEGACY_BUSINESS_PROCESS_CLASS_LABELS = {
  // 廃止レガシー
  Operation:                        "businessProcess.class.operation",
  CustomerRelationshipManagement:   "businessProcess.class.customerRelationshipManagement",
  ProductLifeCycleManagement:       "businessProcess.class.productLifeCycleManagement",
  InvestorRelationshipManagement:   "businessProcess.class.investorRelationshipManagement",
  DataManagement:                   "businessProcess.class.dataManagement",
  ItServiceManagement:              "businessProcess.class.itServiceManagement",
  None:                             "businessProcess.type.other",
  // 旧プロセス制約統制 (PCC)
  ProductDeliveryImprovementProcessConstraintControl:    "businessProcess.class.productDeliveryImprovementPCC",
  ProductPriceImprovementProcessConstraintControl:       "businessProcess.class.productPriceImprovementPCC",
  ProductQualityImprovementProcessConstraintControl:     "businessProcess.class.productQualityImprovementPCC",
  ProductFunctionImprovementProcessConstraintControl:    "businessProcess.class.productFunctionImprovementPCC",
  ServiceDeliveryImprovementProcessConstraintControl:    "businessProcess.class.serviceDeliveryImprovementPCC",
  ServicePriceImprovementProcessConstraintControl:       "businessProcess.class.servicePriceImprovementPCC",
  ServiceQualityImprovementProcessConstraintControl:     "businessProcess.class.serviceQualityImprovementPCC",
  ServiceContentImprovementProcessConstraintControl:     "businessProcess.class.serviceContentImprovementPCC",
  SalesProcessConstraintControl:                         "businessProcess.class.salesPCC",
  MarketingProcessConstraintControl:                     "businessProcess.class.marketingPCC",
  CustomerActivationProcessConstraintControl:            "businessProcess.class.customerActivationPCC",
  CustomerRetentionProcessConstraintControl:             "businessProcess.class.customerRetentionPCC",
  NewProductQualityExplorationProcessConstraintControl:  "businessProcess.class.newProductQualityExplorationPCC",
  NewProductValueExplorationProcessConstraintControl:    "businessProcess.class.newProductValueExplorationPCC",
  NewServiceQualityExplorationProcessConstraintControl:  "businessProcess.class.newServiceQualityExplorationPCC",
  NewServiceValueExplorationProcessConstraintControl:    "businessProcess.class.newServiceValueExplorationPCC",
  JobCapabilityImprovementProcessConstraintControl:      "businessProcess.class.jobCapabilityImprovementPCC",
  ApplicationQualityImprovementProcessConstraintControl: "businessProcess.class.applicationQualityImprovementPCC",
  DataQualityImprovementProcessConstraintControl:        "businessProcess.class.dataQualityImprovementPCC",
  ITQualityImprovementProcessConstraintControl:          "businessProcess.class.itQualityImprovementPCC",
  CorporateCultureDevelopmentProcessConstraintControl:   "businessProcess.class.corporateCultureDevelopmentPCC",
  // 旧仮説制約統制 (HCC)
  ProductDeliveryImprovementHypothesisConstraintControl:    "businessProcess.class.productDeliveryImprovementHCC",
  ProductPriceImprovementHypothesisConstraintControl:       "businessProcess.class.productPriceImprovementHCC",
  ProductQualityImprovementHypothesisConstraintControl:     "businessProcess.class.productQualityImprovementHCC",
  ProductFunctionImprovementHypothesisConstraintControl:    "businessProcess.class.productFunctionImprovementHCC",
  ServiceDeliveryImprovementHypothesisConstraintControl:    "businessProcess.class.serviceDeliveryImprovementHCC",
  ServicePriceImprovementHypothesisConstraintControl:       "businessProcess.class.servicePriceImprovementHCC",
  ServiceQualityImprovementHypothesisConstraintControl:     "businessProcess.class.serviceQualityImprovementHCC",
  ServiceContentImprovementHypothesisConstraintControl:     "businessProcess.class.serviceContentImprovementHCC",
  SalesHypothesisConstraintControl:                         "businessProcess.class.salesHCC",
  MarketingHypothesisConstraintControl:                     "businessProcess.class.marketingHCC",
  CustomerActivationHypothesisConstraintControl:            "businessProcess.class.customerActivationHCC",
  CustomerRetentionHypothesisConstraintControl:             "businessProcess.class.customerRetentionHCC",
  NewProductQualityExplorationHypothesisConstraintControl:  "businessProcess.class.newProductQualityExplorationHCC",
  NewProductValueExplorationHypothesisConstraintControl:    "businessProcess.class.newProductValueExplorationHCC",
  NewServiceQualityExplorationHypothesisConstraintControl:  "businessProcess.class.newServiceQualityExplorationHCC",
  NewServiceValueExplorationHypothesisConstraintControl:    "businessProcess.class.newServiceValueExplorationHCC",
  JobCapabilityImprovementHypothesisConstraintControl:      "businessProcess.class.jobCapabilityImprovementHCC",
  ApplicationQualityImprovementHypothesisConstraintControl: "businessProcess.class.applicationQualityImprovementHCC",
  DataQualityImprovementHypothesisConstraintControl:        "businessProcess.class.dataQualityImprovementHCC",
  ITQualityImprovementHypothesisConstraintControl:          "businessProcess.class.itQualityImprovementHCC",
  CorporateCultureDevelopmentHypothesisConstraintControl:   "businessProcess.class.corporateCultureDevelopmentHCC",
};

export const TYPE_GROUP_KEYS = {
  CoreProcess: ["valueDelivery", "valueCommunication", "valueCreation"],
  BusinessSupportProcess: ["humanCapital", "informationCapital", "organizationCapital", "cashFlow", "logistics", "facilityManagement"],
  EnterpriseSupportProcess: ["enterpriseSupport"],
};

export function getGroupsForType(typeKey) {
  const keys = TYPE_GROUP_KEYS[typeKey] || [];
  return BUSINESS_PROCESS_CLASS_GROUPS.filter((g) => keys.includes(g.key));
}

export function findTypeKeyByValue(classValue) {
  if (classValue === "None") return "other";
  for (const [typeKey, groupKeys] of Object.entries(TYPE_GROUP_KEYS)) {
    for (const gk of groupKeys) {
      const group = BUSINESS_PROCESS_CLASS_GROUPS.find((g) => g.key === gk);
      if (group && group.values.some((v) => v.value === classValue)) return typeKey;
    }
  }
  return "CoreProcess";
}

export function findGroupKeyByValue(value) {
  for (const group of BUSINESS_PROCESS_CLASS_GROUPS) {
    if (group.values.some((v) => v.value === value)) {
      return group.key;
    }
  }
  return BUSINESS_PROCESS_CLASS_GROUPS[0].key;
}
